import { render } from "./ViewPreIngestion.vue?vue&type=template&id=16a3f1ba&scoped=true"
import script from "./ViewPreIngestion.vue?vue&type=script&lang=js"
export * from "./ViewPreIngestion.vue?vue&type=script&lang=js"

import "./ViewPreIngestion.vue?vue&type=style&index=0&id=16a3f1ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a3f1ba"]])

export default __exports__